import { languages } from '../../../../../../shared/app/constants/languages';
import { keycodesModule } from '../../../../../../shared/app/constants/keycodes';
import { codeChallengeProcessServiceModule } from './code-challenge-process-service';
import { appAlertComponentModule } from '../../../../../../shared/app/components/app-alert/app-alert';
import { challengeCodeOfConductComponentModule } from '../../../../../../shared/app/components/challenge-code-of-conduct/challenge-code-of-conduct';
import { languagePickerComponentModule } from '../../../../../../shared/app/components/language-picker/language-picker';
import { interactUserListComponentModule } from '../../../../../../shared/app/components/interact-user-list/interact-user-list';
import { dialogComponentModule } from '../../../../../../shared/app/components/dialog/dialog';
import { compileTemplateComponentModule } from '../../../../../../shared/app/components/compile-template/compile-template';
import codeChallengeTemplate from './code-challenge.tpl.html';
import introDialogTemplate from './code-challenge.intro.tpl.html';
import './code-challenge.less';
import { challengeIntroDialogComponentModule } from '../../../../components/challenge-intro-dialog/challenge-intro-dialog';
import { uiRouterStateModule } from '../../../../../../shared/app/vendor/ui-router-module';
import { codemirrorOptionsComponentModule } from '../../../../../../shared/app/components/codemirror/codemirror-options';
import { resetCodeComponentModule } from '../../../../components/reset-code-dialog/reset-code-dialog';
import { changeLanguageComponentModule } from '../../../../components/change-language-dialog/change-language-dialog';
import { bufferedSaveHelperModule } from '../../../../../../shared/app/helpers/buffered-save-helper/buffered-save-helper';
import { identity } from '../../../../../../shared/app/utils/function-utils';
import { challengeRouteInteractHelperModule } from '../../../../helpers/challenge-route-interact-helper/challenge-route-interact-helper';
import { insertBefore } from '../../../../../../shared/app/utils/array-utils';
import { multiFileChallengeServiceModule } from '../../../../../../shared/app/services/multi-file-challenge-service/multi-file-challenge-service';
import { multiFileLayoutComponentModule } from '../../../../../../shared/app/components/multi-file-layout/multi-file-layout';
import { createInteractParticipantsTab } from '../shared-tabs/interact-participants-tab/interact-participants-tab';
import {
  CLASSIC_CHALLENGE_LAYOUT_PROPS,
  TESTCASES_LABEL_READONLY,
} from '../../../../../../shared/app/constants/classic-challenge-layout-props';

export const codeChallengeRouteModule = angular
  .module('Q.routes.assessments.challenges.code-challenge', [
    keycodesModule,
    uiRouterStateModule,
    codeChallengeProcessServiceModule,
    appAlertComponentModule,
    challengeCodeOfConductComponentModule,
    languagePickerComponentModule,
    interactUserListComponentModule,
    dialogComponentModule,
    compileTemplateComponentModule,
    challengeIntroDialogComponentModule,
    resetCodeComponentModule,
    changeLanguageComponentModule,
    bufferedSaveHelperModule,
    challengeRouteInteractHelperModule,
    multiFileChallengeServiceModule,
    multiFileLayoutComponentModule,
    codemirrorOptionsComponentModule,
  ])

  .config(function ($stateProvider) {
    $stateProvider.state('assessments.challenges.codeChallenge', {
      data: {
        bodyClass: 'assessments challenges classic-code-challenge',
        label: 'Assessment Challenge IDE',
      },
      resolve: {
        challengeProcess: /* @ngInject */ function (
          challenge,
          process,
          codeChallengeProcessService,
        ) {
          return challenge
            ? codeChallengeProcessService.create(challenge, process)
            : null;
        },
      },
      onExit: /* @ngInject */ function (challengeProcess) {
        if (challengeProcess) {
          challengeProcess.autosave('switchedFromChallenge');
          challengeProcess.onExit();
        }
      },
      views: {
        '@assessments': {
          template: codeChallengeTemplate,
          controller: 'CodeChallengeCtrl as $ctrl',
        },
      },
    });
  })

  .controller(
    'CodeChallengeCtrl',
    function CodeChallengeCtrl(
      $scope,
      process,
      challenge,
      challengeProcess,
      codemirrorOptions,
      $state,
      $timeout,
      $window,
      dialogService,
      tracker,
      KeyCodes,
      Challenge,
      Solution,
      bufferedSaveHelper,
      resetCodeDialog,
      changeLanguageDialog,
      challengeRouteInteractHelper,
      multiFileChallengeService,
      $log,
    ) {
      const ctrl = this;

      let challengeItem = process.assessmentResult.getChallengeItem(challenge);
      ctrl.challenge = angular.extend(challenge, {
        position: challengeItem.position,
      });
      ctrl.isCarriedForward = Challenge.isCarriedForward(
        challenge,
        process.assessment,
      );
      ctrl.process = challengeProcess;
      ctrl.required = process.getCurrentStage().required;
      ctrl.nextIsChallenge = process.nextIsChallenge;
      ctrl.nextLabel = process.nextLabel;
      ctrl.next = process.next;
      ctrl.previous = process.previous;
      ctrl.codeStatus = '';
      ctrl.testCasesStatus = '';

      const saveSolution = bufferedSaveHelper(challengeProcess.autosave);
      ctrl.saveSolution = saveSolution;

      const challengeConfig = challengeProcess.mfcChallengeConfig();

      function setupMFCS() {
        const solution = challengeProcess.solution;
        solution.files.forEach((file) => {
          const field = file.field;
          Object.defineProperties(file, {
            status: {
              get() {
                return ctrl[field + 'Status'];
              },
            },
            // store layout options back onto the parent model
            options: {
              get() {
                if (!solution.options) {
                  solution.options = {};
                }
                if (!solution.options[file.id]) {
                  solution.options[file.id] = {};
                }
                return solution.options[file.id];
              },
              set(val) {
                angular.extend(this.options, val);
              },
            },
          });
        });

        const interactFile = createInteractParticipantsTab(process);
        multiFileChallengeService.create({
          enableAiAgent: challengeProcess.challenge.showAiAgentToCandidates,
          svc: ctrl,
          challenge: challengeProcess.challenge,
          solution,
          docsArticleList: [],
          challengeConfig,
          afterFileChanges: saveSolution,
          editChallengeEditorTools(svc) {
            // inserts above help
            insertBefore(
              svc.challengeEditorTools,
              svc.docsArticleFile,
              interactFile,
            );
          },
        });

        ctrl.privilegedMode = 'none';

        ctrl.runResponse = ctrl.runResponse || solution.getRunResponse();

        $scope.$on('$destroy', ctrl.destroy);

        const startInteract = () => {
          if (!ctrl.openFiles.includes(interactFile)) {
            ctrl.openFiles.push(interactFile);
            if (ctrl.fileLayout) ctrl.fileLayout.resetOpenFiles();
          }
          ctrl.startInteract(
            challengeProcess.firebaseRef,
            process.liveInterview,
          );
          challengeProcess.interact = ctrl.interact;
        };
        $scope.$on('liveInterviewStarted', startInteract);
        if (process.liveInterviewActive) {
          $scope.$applyAsync(startInteract);
        }

        const smallWindow = angular.element($window).offsetHeight() < 800;
        const openableFiles = [
          ...ctrl.files,
          ...ctrl.challengeEditorTools,
          ...challengeConfig,
        ];
        let layoutProps = CLASSIC_CHALLENGE_LAYOUT_PROPS;
        if (ctrl.challenge.enableAiAgent) {
          layoutProps = angular.merge({}, CLASSIC_CHALLENGE_LAYOUT_PROPS);
        }
        ctrl.openFiles = Object.entries(layoutProps)
          .map(([id, props]) => {
            const file = openableFiles.find(
              (f) => f.id === id || f.path === id,
            );
            if (file) {
              const layoutProps = Object.assign(
                {},
                props,
                (smallWindow && props.smallWindow) || {},
              );
              Object.entries(layoutProps).forEach(([key, value]) => {
                if (file[key] === undefined) file[key] = value;
              });
              if (file.id === 'testcases') {
                if (!ctrl.challenge.sampleTestCasesEnabled) {
                  file.access = 'hidden';
                } else if (ctrl.challenge.sampleTestCasesReadOnly) {
                  file.access = 'readonly';
                  file.label = TESTCASES_LABEL_READONLY;
                }
              }
              return !file.hidden && file;
            }
            return null;
          })
          .filter(identity);

        const updateArticleList = () => {
          if (!ctrl.docsArticleFile) return;
          ctrl.docsArticleFile.docsArticleList = ctrl.docsArticleList = [
            {
              id: 'for-candidates/challenge-solver/summary',
              title: 'Using the challenge solver',
            },
            {
              id: 'for-candidates/challenge-solver/debugging-tips',
              title: 'Debugging Tips',
            },
          ];
          if (challengeProcess.solution) {
            const langName = languages.toName(
              challengeProcess.solution.language,
            );
            const frameworkName =
              languages.frameworks[challengeProcess.solution.testFramework] ||
              challengeProcess.solution.testFramework;
            ctrl.docsArticleList.push({
              id: 'reference/languages/' + challengeProcess.solution.language,
              title: `About the ${langName} Runtime`,
            });
            if (ctrl.challenge.sampleTestCasesEnabled) {
              ctrl.docsArticleList.push({
                id:
                  'reference/languages/' +
                  challengeProcess.solution.language +
                  '/' +
                  challengeProcess.solution.testFramework,
                title: `Testing with ${frameworkName}`,
              });
            }
          }
        };
        $scope.$watch(
          '$ctrl.process.solution.language+","+$ctrl.process.solution.testFramework',
          updateArticleList,
        );
        updateArticleList();

        ctrl.openInitialFile();
      }

      const _initSolutionTests = () => {
        const solution = challengeProcess.solution;
        let code = languages.stripComments(
          challengeProcess.language,
          solution && solution.testCases,
        );
        ctrl.testsEmpty = !code;
        ctrl.runTestsTooltip = code
          ? ''
          : ' (Make sure you have tests to run!)';
        ctrl.sampleTestCasesEnabled =
          !solution || solution.sampleTestCasesEnabled;
        ctrl.sampleTestCasesReadOnly =
          ctrl.sampleTestCasesEnabled &&
          solution &&
          solution.sampleTestCasesReadOnly;

        solution.files.updatePaths();

        if (ctrl.reconfigureSmartIde) {
          ctrl.reconfigureSmartIde();
        }

        if (ctrl.interact) {
          const files = solution.files.map((file) => ({
            id: file.interactId,
            properties: { contents: file.contents },
          }));

          ctrl.interact.updateFiles(files);
        }
      };

      const lastAttempt = {
        code: '',
        response: {},
        language: null,
      };

      const requireSubmit = () => {
        return (
          challengeProcess.solution && // we have a solution
          !ctrl.expired && // the timer hasn't expired
          !ctrl.attemptedCurrentSolution() && // we have _not_ run the current solution
          !ctrl.isSample() && // we are not in practice or demo mode
          process.assessmentResult.isStarted() && // the assessment result is in the started state
          !process.restricted && // we're not in a restricted editing mode
          !process.liveInterviewActive
        ); // we're not in a live interview
      };

      ctrl.openResetDialog = () =>
        resetCodeDialog.open(challengeProcess).finally(_initSolutionTests);
      ctrl.openChangeLanguageDialog = () =>
        changeLanguageDialog
          .open(
            challengeProcess.solution,
            ctrl.languageIds,
            ctrl.switchLanguage,
          )
          .finally(_initSolutionTests);

      $scope.$on('$stateChangeStart', (event, toState) => {
        if (toState.name !== 'assessments.welcome' && requireSubmit()) {
          // yell at the candidate for not submitting their code
          event.preventDefault();

          $timeout(() => {
            tracker.trackEvent('User Did Not Submit Challenge');
            dialogService
              .confirm(
                `\
<p>Please submit your solution ${challengeProcess.solution.attempts ? 'with your current changes' : 'at least once'} before continuing, using the <em>Submit Solution</em> button in the top right.</p>
<p>Would you like to submit your solution now?</p>
`,
                'Submit Solution',
                [
                  { id: 'yes', text: 'Submit Solution' },
                  { id: 'cancel', text: 'Continue Editing' },
                ],
              )
              .then(ctrl.submitSolution);
          });
        }
      });

      challengeProcess.resaveAfterFail = () => saveSolution('resaveAfterFail');

      const solution = challengeProcess.solution;
      const buildCodeOfConductState = () => {
        const team = process.assessment && process.assessment.team;
        const enabled = !!(
          team &&
          team.hasFeature('codeOfConduct') &&
          challenge.cocEnabled
        );
        const rules = enabled ? challenge.codeOfConductRules() : [];
        rules.forEach((rule) => {
          rule.acknowledged = false;
        });
        return {
          enabled,
          rules,
          requireAcknowledgement:
            enabled && challenge.cocRequireAcknowledgement !== false,
        };
      };

      ctrl.codeOfConduct = buildCodeOfConductState();
      ctrl.codeOfConductAcknowledged = () => {
        if (!ctrl.codeOfConduct.enabled) return true;
        if (!ctrl.codeOfConduct.requireAcknowledgement) return true;
        return ctrl.codeOfConduct.rules.every((rule) => rule.acknowledged);
      };

      if (solution) {
        challengeProcess.autosave('switchedToChallenge');
        lastAttempt.response = ctrl.initialResponse = solution.getRunResponse();
        const result = lastAttempt.response.result;
        if (result && (result.passed > 0 || result.failed > 0)) {
          // we're trying to guess if they've run this code or not when reloading
          lastAttempt.code = solution.code;
          lastAttempt.language = solution.language;
        }
        _initSolutionTests();
        setupMFCS();
      } else {
        ctrl.codemirrorOpts = codemirrorOptions;
        ctrl.showIntro = true;
        ctrl.introDialogTemplate = introDialogTemplate;
        ctrl.unableToBeginChallenge = () =>
          ctrl.unattemptedReferenceSolution ||
          !ctrl.currentLanguage ||
          !ctrl.codeOfConductAcknowledged() ||
          ctrl.beginning;
        ctrl.beginChallenge = () => {
          if (ctrl.unableToBeginChallenge()) return;
          ctrl.beginning = true;
          challengeProcess
            .beginChallenge()
            .then(() => {
              _initSolutionTests();
              setupMFCS();
              process.addSolution(challengeProcess.originalSolution);
              ctrl.showIntro = false;
            })
            .catch($log.error)
            .finally(() => {
              $timeout(() => {
                // delayed to let dialog close
                ctrl.beginning = false;
              }, 100);
            });
        };
      }

      const prevSol = Challenge.getCarriedForwardIds(challenge)
        .map(
          (cfId) =>
            Solution.filter({
              assessmentResultId: process.assessmentResult.id,
              challengeId: cfId,
            })[0],
        )
        .filter(angular.identity)[0];
      let availableLanguages;
      if (prevSol && prevSol.language) {
        // if this is a carry forward, and we have a previous solution, lock down the language
        availableLanguages = [languages[prevSol.language]];
      } else if (
        solution &&
        solution.language &&
        Challenge.hasBeenCarriedForward(challenge, process.assessmentResult)
      ) {
        // if this is the first solution in a series of carry forward, and we've started the second, lock down the language
        availableLanguages = [languages[solution.language]];
      } else {
        availableLanguages = challengeItem.availableLanguages();
      }
      availableLanguages.sort(languages.compare);
      ctrl.languageIds = availableLanguages.map((l) => l.id);

      function _setLanguage() {
        if (!languages[challengeProcess.language]) {
          $log.error(
            "Invariant violation: expected languages[challengeProcess.language] to be defined, but it wasn't",
          );
          return;
        }

        const lang = languages[challengeProcess.language].id;
        if (challengeProcess.challengeLanguagePicked) {
          ctrl.currentLanguage = lang;
          ctrl.currentLanguageName = languages[lang].name;
        }
        ctrl.currentChallengeLanguage = ctrl.challenge.languages.find(
          (language) => language.name === lang,
        );

        ctrl.unattemptedReferenceSolution =
          ctrl.incompleteReferenceSolution =
          ctrl.completeReferenceSolution =
            false;

        if (ctrl.currentChallengeLanguage && !challengeProcess.solution) {
          // for showing carry forward warnings in the intro dialog
          const challengeIds = process.challengeItems.map(
            (ci) => ci.challengeId,
          );
          const referenceIds =
            ctrl.currentChallengeLanguage.challengeReferenceIds;
          const referenced =
            referenceIds.length &&
            referenceIds.every((referenceId) =>
              challengeIds.includes(referenceId),
            );
          if (referenced) {
            const referenceStatus =
              ctrl.currentChallengeLanguage.referenceSolutionsStatus;
            ctrl.unattemptedReferenceSolution =
              referenceStatus === 'unattempted' || referenceStatus === 'none';
            ctrl.incompleteReferenceSolution = referenceStatus === 'incomplete';
            ctrl.completeReferenceSolution = referenceStatus === 'complete';
          }
        }
      }

      ctrl.switchLanguage = function (language) {
        const promise = challengeProcess.switchToLanguage(language);
        _setLanguage();
        return promise;
      };

      if (ctrl.languageIds.length === 1) {
        // if there's only one, make sure it's selected
        challengeProcess.switchToLanguage(ctrl.languageIds[0]);
      }

      _setLanguage();

      ctrl.runTests = function () {
        if (
          !challengeProcess.solution ||
          ctrl.beginning ||
          !ctrl.sampleTestCasesEnabled ||
          ctrl.testsEmpty ||
          ctrl.expired
        ) {
          // don't run tests if we're not ready, they are disabled, or they are empty
          return;
        }
        ctrl.openFile(ctrl.runnerFrameFile);
        ctrl.codeStatus = ctrl.testCasesStatus = '';
        challengeProcess.runTests().then(function (data) {
          let result = (data && data.result) || {};
          if (result.passed && !result.errors && !result.failed) {
            ctrl.testCasesStatus = 'success';
          } else if (result.errors || result.failed) {
            ctrl.testCasesStatus = 'danger';
          }
        });
      };

      ctrl.submitSolution = function () {
        if (!challengeProcess.solution || ctrl.beginning || ctrl.expired) {
          // don't submit until we're ready
          return;
        }
        ctrl.openFile(ctrl.runnerFrameFile);
        ctrl.codeStatus = '';
        challengeProcess.submitSolution().then(() => {
          lastAttempt.code = challengeProcess.solution.code;
          lastAttempt.language = challengeProcess.solution.language;
          lastAttempt.response = challengeProcess.runResponse || {};

          if (ctrl.isCompleted()) {
            ctrl.codeStatus = 'success';
          } else {
            ctrl.codeStatus = 'danger';
          }
        });
      };

      challengeRouteInteractHelper.init(ctrl, process, $scope);

      ctrl.isSample = process.isSample;

      const _hasChangedSolution = () => {
        const solution = challengeProcess.solution;
        return !(
          solution &&
          lastAttempt.code === solution.code &&
          lastAttempt.language === solution.language
        );
      };

      ctrl.testsPassed = function () {
        return (
          !ctrl.sampleTestCasesEnabled ||
          ctrl.testCasesStatus === 'passed' ||
          ctrl.isCompleted()
        );
      };

      ctrl.attemptedCurrentSolution = function () {
        if (_hasChangedSolution()) {
          return false;
        } else {
          return !!lastAttempt.response.result;
        }
      };

      ctrl.isCompleted = function () {
        if (ctrl.attemptedCurrentSolution()) {
          const result = lastAttempt.response.result;
          if (result) {
            // with hidden cases, we can't rely on completed to be true :-\
            return (
              result.completed ||
              (result.passed > 0 && result.errors === 0 && result.failed === 0)
            );
          } else {
            return (
              challengeProcess.solution && challengeProcess.solution.completedAt
            );
          }
        }
        return false;
      };

      challengeProcess.onEnter($scope);
    },
  );
